import { createSelector } from "reselect"
import { get } from "lodash"
import moment from "moment"
import { getDate } from "./dates"
import { getFilter, getNormalization } from "./filters"
import { getAllAvailableRollups } from "helpers/rollups"
import { VIEW_TYPES } from "helpers/base"
import { getTagCategories, getAttributeCategories } from "modules/portfolio-root/selectors"
import { REFRESHING } from "model/intraday"
import { TIME_FORMAT_TZ } from "helpers/dates"
import { computeFilteredSegment } from "helpers/segments"
import { MENU_ITEMS_GROUPS } from "helpers/menu"

export const getRawSort = state => get(state, "modules.intraday.sort")
export const getSelectedPage = state => get(state, "modules.intraday.page")
export const getRawIntradayRefreshStatus = state => get(state, "global.intraday.refresh")
export const getAccount = state => get(state, "global.selected.account")
export const getPortfolioId = state => get(state, "global.data.portfolio.data.id")
export const getPortfolioIntradayEnabled = state => get(state, "global.data.portfolio.data.intradayEnabled", false)
export const getAccountId = state => get(state, "global.selected.accountId")
const getClassifications = state => get(state, "global.data.classifications.data.classifications")
const getIntradayLastBatchTime = state => get(state, "global.data.intradayLastBatch.data.asOf")
const getIntradayLastBatch = state => get(state, "global.data.intradayLastBatch.data")
export const getSelectedScreen = (_, props) => get(props, "params.selectedScreen")
export const getGrouping = state => get(state, "modules.intraday.grouping")

export const getIsRefreshing = createSelector(
  [getRawIntradayRefreshStatus, getAccountId, getPortfolioId],
  ({ status, channel }, accountId, portfolioId) => status === REFRESHING && `${accountId}_${portfolioId}` === channel,
)

const getAccountRollups = createSelector(
  [getClassifications, getTagCategories, getAttributeCategories],
  (classifications, tagCategories, attributeCategories) => ({
    classifications,
    tagCategories,
    attributeCategories,
  }),
)

export const getAvailableRollups = createSelector(
  [getAccountRollups, getDate],
  (accountRollups, date) => getAllAvailableRollups(accountRollups, date, VIEW_TYPES.ABSOLUTE),
)

export const getSegment = createSelector(
  [getFilter, getNormalization],
  computeFilteredSegment,
)

export const getHasData = createSelector(
  [getIntradayLastBatchTime],
  (lastBatchTime) => lastBatchTime != null && moment(lastBatchTime, TIME_FORMAT_TZ).isValid(),
)

export const getLastRefresh = createSelector(
  [getHasData, getIntradayLastBatchTime],
  (hasData, lastBatchTime) => {
    if (hasData) {
      return moment(lastBatchTime, TIME_FORMAT_TZ).format("LTS")
    }
    return moment().format("LTS")
  },
)

export const getIntradayLastBatchId = createSelector(
  [getIntradayLastBatch],
  (lastBatchData) => get(lastBatchData, "id"),
)

export const getMenuItems = () => ([
  {
    id: "assets",
    label: "Assets Review",
    tooltip: "Review key analytics for each asset held in this portfolio",
    order: 0,
    ...MENU_ITEMS_GROUPS.layout,
  },
  {
    id: "factors",
    label: "Factors Review",
    tooltip: "Review predicted risk & factors risk attribution",
    order: 1,
    ...MENU_ITEMS_GROUPS.layout,
  },
])
